import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Jira-style drag-and-drop for a Space board. Makes every column a Sortable
// list; on drop it persists the moved card's new column (status) and the
// column's new ordering to StoriesController#reorder.
//
// Real-time updates: background agent moves (and drags from other sessions)
// broadcast a full board re-render to the `space_board_<id>` Turbo stream the
// page subscribes to; Stimulus re-instantiates this controller on the new DOM.
export default class extends Controller {
  static targets = ["column"]
  static values  = { reorderUrl: String }

  connect() {
    this.sortables = this.columnTargets.map((col) =>
      Sortable.create(col, {
        group: "space-board",
        animation: 150,
        draggable: ".board-card",
        ghostClass: "opacity-40",
        // Drags begin only on real movement, so a click still toggles the
        // card's <details> editor.
        onEnd: (evt) => this.persist(evt),
      })
    )
  }

  disconnect() {
    this.sortables?.forEach((s) => s.destroy())
    this.sortables = null
  }

  persist(evt) {
    const column = evt.to
    const status = column.dataset.status
    const order = Array.from(column.querySelectorAll(".board-card")).map(
      (el) => el.dataset.storyId
    )
    const movedId = evt.item.dataset.storyId

    const body = new URLSearchParams()
    body.append("id", movedId)
    body.append("status", status)
    order.forEach((id) => body.append("order[]", id))

    fetch(this.reorderUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/plain",
      },
      body,
    }).then((res) => {
      if (!res.ok) window.location.reload() // re-sync on validation failure
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
